<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Devices</div>
              <q-btn
                v-if="['superAdmin', 'appAdmin'].includes(currentUserData.role)"
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                v-if="['superAdmin'].includes(currentUserData.role)"
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                unelevated
                no-caps
                @click="downloadCSV"
              >
                <q-icon
                  name="mdi-download"
                  color="accent"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Download CSV
              </q-btn>
              <q-btn
                v-if="['superAdmin'].includes(currentUserData.role)"
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                unelevated
                no-caps
                :loading="uploadDataLoading"
                @click="uploadDevicesCsv"
              >
                <q-icon
                  name="mdi-upload"
                  color="accent"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Upload CSV
              </q-btn>
              <q-input
                ref="uploadDataInput"
                style="display: none"
                v-model="file"
                type="file"
                label="Standard"
                accept=".csv"
              ></q-input>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="devicesLoading"
                @click="$store.dispatch('devices/loadAll')"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="devices">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 160px) !important"
                >
                  <datatable
                    ref="dataTable"
                    :filter="search"
                    :flat="true"
                    :data="devices"
                    :columns="columns"
                    selection="multiple"
                    @rowDoubleClick="handleDoubleClick"
                    updateBody
                  >
                    <template slot="body" slot-scope="data">
                      <q-tr
                        @click="
                          $refs.dataTable.handleClick(null, data.props.row)
                        "
                        @dblclick="
                          $refs.dataTable.handleDoubleClick(
                            null,
                            data.props.row
                          )
                        "
                        :props="data.props"
                        :class="{
                          'bg-red': data.props.row.batteryThresholdOverride
                            ? parseFloat(
                                data.props.row.batteryThresholdOverride
                              ) > parseFloat(data.props.row.battery)
                            : parseFloat(data.props.row.batteryThreshold) >
                              parseFloat(data.props.row.battery),
                          'bg-primary': data.props.row.heartbeatFlag == 1
                        }"
                      >
                        <q-td auto-width>
                          <q-checkbox v-model="data.props.selected" />
                        </q-td>
                        <template
                          v-for="column in data.props.cols"
                          :name="`body-cell-${column.name}`"
                          v-bind:props="data.props"
                        >
                          <q-td
                            v-if="column.name == 'lastMessageReceived'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <div
                              style="display: inline-block"
                              class="q-mr-sm"
                              v-if="data.props.row.lastMessageReceived"
                            >
                              {{
                                data.props.row.lastMessageReceived
                                  | momentFromNow
                              }}
                            </div>
                            <q-tooltip
                              v-if="data.props.row.lastMessageReceived"
                            >
                              {{
                                data.props.row.lastMessageReceived
                                  | momentFormat
                              }}
                            </q-tooltip>
                          </q-td>
                          <q-td
                            v-else-if="column.name == 'relevantData'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <component
                              v-if="
                                data.props.row.companyDeviceType &&
                                  data.props.row.deviceSet
                              "
                              :data="data"
                              :is="
                                relevantDataComponents[
                                  data.props.row.companyDeviceType
                                ][data.props.row.deviceSet]
                              "
                            ></component>
                          </q-td>
                          <q-td v-else :key="column.name" :props="data.props">
                            {{ column.value }}
                          </q-td>
                        </template>
                      </q-tr>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" max-width="600px">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">New Device</div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <deviceForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="state => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Device</div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <deviceForm
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="state => (saveLoading = state)"
          />
        </q-card-section>
        <!-- <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section> -->
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import deviceForm from "@/components/devices/deviceForm.vue";
import moment from "moment";
import critterpicPicture from "@/components/deviceTypes/customDataComponents/critterpicPicture.vue";
import flexicommsTrap from "@/components/deviceTypes/customDataComponents/flexicommsTrap.vue";
import rockblockTrap from "@/components/deviceTypes/customDataComponents/rockblockTrap.vue";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    deviceForm,
    critterpicPicture
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      devices: "devices/list",
      devicesLoading: "devices/listLoading"
    })
  },
  watch: {
    file: function() {
      if (this.file != null) {
        this.uploadDataReady();
      }
    }
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "id",
        label: "ID",
        align: "left",
        field: "id",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "battery",
        label: "Battery",
        align: "left",
        field: "battery",
        format: val => (val ? `${val} V` : ""),
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "temp",
        label: "Temperature",
        align: "left",
        field: "temp",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "lastMessageReceived",
        label: "Last Received Event",
        align: "left",
        field: "lastMessageReceived",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "deployments_id",
        label: "DeploymentID",
        align: "left",
        field: "deployments_id",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "deployments_start_ts",
        label: "Deployment Start",
        align: "left",
        field: "deployments_start_ts",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "relevantData",
        label: "Relevant Data",
        align: "left",
        field: "relevantData",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: false
      },
      {
        name: "deviceType",
        label: "Type",
        align: "left",
        field: "type_name",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: false
      },
      {
        name: "k",
        label: "Device Key",
        align: "left",
        field: "k",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "rb_k",
        label: "Rockblock Key",
        align: "left",
        field: "rb_k",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "isHub",
        label: "Is a Hub",
        align: "left",
        field: "isHub",
        format: val => (val != 0 ? "Hub" : ""),
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "mirror",
        label: "Mirroring",
        align: "left",
        field: "mirror",
        format: val => (val != 0 ? "Mirroring" : ""),
        style:
          "min-width: 120px;max-width: 120px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "overlaysEnabled",
        label: "Overlay Enabled",
        align: "left",
        field: "overlaysEnabled",
        format: val => (val != 0 ? "Enabled" : ""),
        style:
          "min-width: 120px;max-width: 120px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "parentKey",
        label: "Parent Key",
        align: "left",
        field: "parentKey",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "pcb_id",
        label: "PCB ID",
        align: "left",
        field: "pcb_id",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "version",
        label: "Firmware",
        align: "left",
        field: "version",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "sim",
        label: "SIM",
        align: "left",
        field: "sim",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "lat",
        label: "Lat",
        align: "left",
        field: "lat",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "long",
        label: "Long",
        align: "left",
        field: "long",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "comment",
        label: "Comment",
        align: "left",
        field: "comment",
        style:
          "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "created_at",
        label: "Created At",
        align: "left",
        field: "created_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "updated_at",
        label: "Updated At",
        align: "left",
        field: "updated_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "applications_name",
        label: "Application",
        align: "left",
        field: "applications_name",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "organizations_name",
        label: "Organization",
        align: "left",
        field: "organizations_name",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "ownerships_start_ts",
        label: "Ownership Start",
        align: "left",
        field: "ownerships_start_ts",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      }
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    // file
    file: null,
    uploadDataLoading: false,

    relevantDataComponents: {
      Critterpic: {
        Picture: critterpicPicture
      },
      "Flexi-comms": {
        Trap: flexicommsTrap,
        "Trap (rb)": rockblockTrap
      }
    }
  }),
  beforeCreate() {
    this.$store.dispatch("devices/loadAll");
  },
  mounted() {},
  methods: {
    handleDoubleClick(row) {
      this.viewFormData = row;
      this.viewDetailsDialog = true;
    },
    downloadCSV() {
      let filename = "devices.csv";

      let text = this.generateCSV(this.$refs.dataTable.selected);

      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    generateCSV(devices) {
      const csvString = [
        Object.keys(devices[0]),
        ...devices.map(item => Object.values(item))
      ]
        .map(e => e.join(","))
        .join("\n");

      return csvString;
    },
    uploadDevicesCsv() {
      this.$refs.uploadDataInput.$el.click();
    },
    uploadDataReady() {
      let reader = new FileReader();
      reader.readAsText(this.file[0]);
      reader.onload = () => {
        let delimiter = ",";
        let str = reader.result;
        const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
        const rows = str.slice(str.indexOf("\n") + 1).split("\n");
        const arr = rows.map(function(row) {
          const values = row.split(delimiter);
          const el = headers.reduce(function(object, header, index) {
            object[header] = values[index];
            return object;
          }, {});
          return el;
        });
        this.uploadDataLoading = true;
        this.$store
          .dispatch("devices/createMultiple", {
            data: arr
          })
          .then(res => {
            this.$q.notify({
              message: "Devices Created",
              color: "positive"
            });
            this.uploadDataLoading = false;
          });
      };
    }
  }
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
